import Auth from '@aws-amplify/auth';
import { ConsoleLogger as Logger, JS } from '@aws-amplify/core';
import { Button } from '@rmwc/button';
import { TextField, TextFieldHelperText as HelperText } from '@rmwc/textfield';
import { AuthPiece } from 'aws-amplify-react/dist/Auth';
import * as React from 'react';

const logger = new Logger('RequireNewPassword');

export default class CustomRequireNewPassword extends AuthPiece {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
        };

        this._validAuthStates = ['requireNewPassword'];
        this.change = this.change.bind(this);
        this.checkContact = this.checkContact.bind(this);
    }

    handleInputChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    checkContact(user) {
        if (!Auth || typeof Auth.verifiedContact !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.verifiedContact(user).then(data => {
            if (!JS.isEmpty(data.verified)) {
                this.changeState('signedIn', user);
            } else {
                user = Object.assign(user, data);
                this.changeState('verifyContact', user);
            }
        });
    }

    change(event) {
        event.preventDefault();
        const user = this.props.authData;
        const { password } = this.state;
        const { requiredAttributes } = user.challengeParam;
        const attrs = objectWithProperties(this.state, requiredAttributes);

        if (!Auth || typeof Auth.completeNewPassword !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.completeNewPassword(user, password, attrs)
            .then(user => {
                logger.debug('complete new password', user);
                if (user.challengeName === 'SMS_MFA') {
                    this.changeState('confirmSignIn', user);
                } else if (user.challengeName === 'MFA_SETUP') {
                    logger.debug('TOTP setup', user.challengeParam);
                    this.changeState('TOTPSetup', user);
                } else {
                    this.checkContact(user);
                }
            })
            .catch(err => this.error(err));
    }

    showComponent() {
        const { hide } = this.props;
        if (hide && hide.includes(CustomRequireNewPassword)) {
            return null;
        }
        const user = this.props.authData;
        const { requiredAttributes } = user.challengeParam;

        return (
            <div className="login-wrapper">
                <img src="/images/logo-large-en.png" alt="JD Marketplace" />
                <div className="login-paper">
                    <form className="login-form" onSubmit={this.change}>
                        <TextField
                            label="New Password"
                            helpText={<HelperText>Enter your password</HelperText>}
                            outlined={true}
                            autoFocus
                            name="password"
                            type="password"
                            onChange={this.handleInputChange}
                            value={this.state.password}
                        />
                        {requiredAttributes.map(attribute => (
                            <TextField
                                label={convertToPlaceholder(attribute)}
                                outlined={true}
                                key={attribute}
                                name={attribute}
                                type="text"
                                onChange={this.handleInputChange}
                                value={this.state[attribute]}
                            />
                        ))}
                        <Button
                            type="submit"
                            raised
                            className="login-button mdc-theme--primary-bg mdc-theme--on-primary"
                        >
                            Sign in
                        </Button>
                    </form>
                    <div className="forgot-wrapper">
                        <button className="link-button" onClick={() => this.changeState('signIn')}>
                            Back to Sign In
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

function convertToPlaceholder(str) {
    return str
        .split('_')
        .map(part => part.charAt(0).toUpperCase() + part.substr(1).toLowerCase())
        .join(' ');
}

function objectWithProperties(obj, keys) {
    const target = {};
    for (const key in obj) {
        if (keys.indexOf(key) === -1) {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
            continue;
        }
        target[key] = obj[key];
    }
    return target;
}
